module.exports = __webpack_public_path__ + "static/media/dank_coin.3a7c1de5.gif";